module.exports = __webpack_public_path__ + "static/media/icon_warning_qmark.0861c9e4.svg";